import { Helper } from "../core/util/helper";
import { Config } from "../core/config/config";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export default class DateExample extends React.Component<any, {now: Date}>{

    private refresh: number;
    private intervalToken: number;
    private translations: StringKeyDictionary<string>;
    constructor(props) {
        super(props)
        this.refresh = (props.refresh || 1000);
        this.intervalToken = null;
        this.translations = {
            "Standard.Example": "Example"
        }
        this.state = {
            now: new Date()
        }
        this.initApp();
    }

    private initApp = async () => {
        this.translations = await this.loadTranslations();
        this.setState({})
    }

    private loadTranslations = () => {
        return new Promise<StringKeyDictionary<string>>(async (resolve) => {
            const saveId = "delphiDateExample_" + Config.user.languageId;
            let translations = Helper.loadDataFromStorage(saveId);
            if (Helper.hasValue(translations)) {
                resolve(translations)
            } else {
                const result = await Helper.getTranslations(["Standard.Example"]);
                if (result.Code == 0) {
                    translations = result.Data;
                    Helper.saveDataToStorage(saveId, translations, false);
                    resolve(translations)
                }
            }
        });
    }

    private createText = () => {
        const format = this.getFormat();
        if (!Helper.isNullOrEmpty(format)) {
            return moment(this.state.now).locale(Helper.getBrowserLanguage()).format(format).toString();
        } else {
            return null;
        }
    }

    private getFormat = () => {
        switch ((this.props.context.contextType as string)) {
            case "reportMetaData":
                return DateHelper.ParseDateFormat(this.props.entity.SignatureDateFormat);
            case "generalSettings":
                return DateHelper.ParseDateFormat(this.props.entity.GeneralSettings.DefaultQrDateFormat);
            default:
                 return DateHelper.ParseDateFormat("dd'.'mm'.'yyyy");
        }
    }

    componentDidMount() {
        if (Helper.hasValue(this.refresh)) {
            this.intervalToken = window.setInterval(() => {
                this.setState({ now: new Date() });
            }, this.refresh)
        }
    }

    componentWillUnmount() {
        if (Helper.hasValue(this.intervalToken))
            clearInterval(this.intervalToken);
    }

    render() {
        let text = this.createText();
        if (!Helper.isNullOrEmpty(text)) {
            text = this.translations["Standard.Example"] + ": " + text;
        }
        return (
            <div style={{ display: "flex", flexDirection: "row-reverse", marginTop: "2px", fontSize: "small" }}>
                {text}
            </div>
        );
    }
}

class DateHelper {
    private static dict = {
        "(?<!d)d{6}(?!d)": "",
        "(?<!d)d{5}(?!d)": "",
        "(?<!d)d{4}(?!d)": "dddd",
        "(?<!d)d{3}(?!d)": "ddd",
        "(?<!d)d{2}(?!d)": "DD",
        "(?<!d)d{1}(?!d)": "D",
        "(?<!m)m{4}(?!m)": "MMMM",
        "(?<!m)m{3}(?!m)": "MMM",
        "(?<!m)m{2}(?!m)": "MM",
        "(?<!m)m{1}(?!m)": "M",
        "(?<!y)y{4}(?!y)": "YYYY",
        "(?<!y)y{2}(?!y)": "YY",
        "(?<!h)h{2}(?!h)": "HH",
        "(?<!h)h{1}(?!h)": "H",
        "(?<!n)n{2}(?!n)": "mm",
        "(?<!n)n{1}(?!n)": "m",
        "(?<!s)s{2}(?!s)": "ss",
        "(?<!s)s{1}(?!s)": "s"
    }

    static ParseDateFormat = (format: string) => {
        format = DateHelper.ExcapeHighCommas(format);
        format = DateHelper.ParseByPattern(format);
        return format;
    }

    private static ExcapeHighCommas = (format: string) => {
        let reg = new RegExp("'[^']+'", "g");

        return format.replace(reg, (match) => {
            let result = "";
            let arr = match.split('');
            if (arr.length > 2) {
                result = "[";
                for (let i = 1; i < arr.length -1; i++) {
                    result += arr[i];
                }
                result += "]";
            }
            return result;
        });
    }

    private static ParseByPattern = (format: string) => {
        let reg1: RegExp = new RegExp("\\[(.*?)\\]", "g");
        let dict = {};
        let result = format;
        if (!Helper.isNullOrEmpty(result)) {
            const matches = format.match(reg1);
            if (Helper.hasValue(matches) && matches.length > 0) {
                matches.forEach((value: string, index: number) => {
                    let key = "~~" + index.toString() + "~~";
                    result = result.replace(value, key);
                    dict[key] = value;
                });
            }            
            Object.keys(DateHelper.dict).forEach((key) => {
                result = result.replace(new RegExp(key, "g"), DateHelper.dict[key]);
            });
            Object.keys(dict).forEach((key) => {
                result = result.replace(key, dict[key]);
            });
        }
        return result;
    }
}